// client/legend-cms/src/predictionCampaigns/PredictionCampaignList.js
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  BooleanField,
  EditButton,
  TextInput,
  useRecordContext,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles({
  activeChip: {
    backgroundColor: '#00F5A8',
    color: '#000',
    fontWeight: 700,
  },
  inactiveChip: {
    fontWeight: 700,
  },
});

const filters = [<TextInput label="Buscar" source="q" alwaysOn />];

const StatusChip = () => {
  const record = useRecordContext();
  const classes = useStyles();

  if (!record) return null;

  return (
    <Chip
      size="small"
      label={record.active ? 'Ativa' : 'Inativa'}
      className={record.active ? classes.activeChip : classes.inactiveChip}
    />
  );
};

const PredictionCampaignList = (props) => (
  <List {...props} filters={filters} sort={{ field: 'id', order: 'DESC' }}>
    <Datagrid bulkActionButtons={false}>
      <StatusChip label="Status" />
      <TextField source="slug" label="Slug" />
      <TextField source="title" label="Título" />
      <BooleanField source="top_four_enabled" label="Top 4" />
      <BooleanField source="ranking_enabled" label="Ranking" />
      <DateField source="starts_at" label="Início" showTime />
      <DateField source="ends_at" label="Fim" showTime />
      <EditButton />
    </Datagrid>
  </List>
);

export default PredictionCampaignList;
